import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './TableCell.scss';

export default function TableCell({ blockLabel, children, className, colSpan, label }) {
  const labelClassNames = cn('table-cell__label', {
    'table-cell__label--block': blockLabel
  });

  return (
    <td className={cn('cp-table-cell', className)} colSpan={colSpan}>
      {label && children && <span className={labelClassNames}>{label}</span>}
      {children}
    </td>
  );
}

TableCell.defaultProps = {
  colSpan: 1
};

TableCell.propTypes = {
  blockLabel: PropTypes.bool,
  children: childrenShape,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
